import axios from '@/plugins/axios/https';

export function ApiLogin({ username, password }) {
  const form = {
    username,
    password
  };
  return axios.post('/accounts/login/', form);
}

export function ApiForgotPassMail({ email }) {
  const form = {
    email
  };
  return axios.post('/accounts/forgot-password/', form);
}

export function ApiCheckResetPassToken({ token }) {
  const form = {
    token
  };
  return axios.post('/accounts/verify-reset-password-token/', form);
}

export function ApiResetPassword({ password, token }) {
  const form = {
    password,
    token
  };
  return axios.post('/accounts/reset-password/', form);
}

export function ApiRoleList() {
  return axios.get('/accounts/role-list/');
}

export function ApiAddRole({ name }) {
  const form = {
    name
  };
  return axios.post('/accounts/add-role/', form);
}

export function ApiDeleteRole({ uuid }) {
  return axios.post(`/accounts/delete-role/${uuid}/`);
}

export function ApiProfileView({ uuid }) {
  return axios.get(`/accounts/profile-view/${uuid}/`);
}

export function ApiEditRolePermission({ uuid, permission }) {
  const form = {
    uuid,
    permission
  };
  return axios.post('/accounts/edit-role-permission/', form);
}

export function ApiRoleRename({ uuid, name }) {
  const form = {
    uuid,
    name
  };
  return axios.post('/accounts/edit-role-name/', form);
}

export function ApiMemberList({ search, limit, offset, ordering }) {
  const form = {
    limit,
    offset,
    ordering
  };

  if (search) {
    form.search = search;
  }

  return axios.get('/accounts/member-list/', form);
}

export function ApiMemberProfile({ uuid }) {
  return axios.get(`/accounts/member/${uuid}/`);
}

export function ApiMemberEnable({ uuid, state }) {
  return axios.post(`/accounts/member/${uuid}/${state}/`);
}

export function ApiMemberCreate({ email, name, roleUuid, permission }) {
  const form = {
    email,
    name,
    roleUuid,
    permission
  };
  return axios.post('/accounts/member/create/', form);
}

export function ApiMemberDelete({ uuid }) {
  return axios.post(`/accounts/member/${uuid}/delete/`);
}

export function ApiEditMemberRole({ roleUuid, memberUuid }) {
  const form = {
    roleUuid,
    memberUuid
  };
  return axios.post('/accounts/member/edit-role/', form);
}

export function ApiEditMemberName({ name, memberUuid }) {
  const form = {
    name,
    memberUuid
  };
  return axios.post('/accounts/member/edit-name/', form);
}

export function ApiEditMemberPermission({ uuid, permission }) {
  const form = {
    uuid,
    permission
  };
  return axios.post('/accounts/member/edit-permission/', form);
}

export function ApiGetAccountCurrent() {
  return axios.get('/accounts/current/');
}
